import api from "./api";
import API_ROUTES from "./apiRoutes";
import { toast } from "react-toastify";

/**
 * Generate flats (first time only)
 */
export const generateFlats = async (payload) => {
  try {
    const res = await api.post(API_ROUTES.flats.generate, payload);

    toast.success(`Generated ${res.data.inserted || "units"}`);
    return res.data;
  } catch (error) {
    const message =
      error?.data?.error ||
      error?.data?.message ||
      error.message ||
      "Failed to generate flats";

    toast.error(message);
    throw error;
  }
};

/**
 * Get flats by society
 */
export const getFlatsBySociety = async (societyId) => {
  try {
    const res = await api.get(API_ROUTES.flats.bySociety(societyId));
    return res.data;
  } catch (error) {
    const message =
      error?.data?.error ||
      error?.data?.message ||
      "Failed to fetch flats";

    toast.error(message);
    throw error;
  }
};

/**
 * Get assigned flats
 */
export const getAssignedFlatIdsBySociety = async (societyId) => {
  const res = await api.get(API_ROUTES.flats.assigned, {
    params: { societyId },
  });
  return res.data;
};

/**
 * Get flat details
 */
export const getFlatById = async (flatId) => {
  try {
    const res = await api.get(API_ROUTES.flats.details(flatId));
    return res.data;
  } catch (error) {
    const message =
      error?.data?.error ||
      error?.data?.message ||
      error.message ||
      "Failed to fetch flat details";

    toast.error(message);
    throw error;
  }
};

/**
 * Update unit types only
 */
export const bulkUpdateFlatUnitTypes = async (updates = []) => {
  if (!updates.length) return;

  try {
    const res = await api.put(API_ROUTES.flats.unitTypesBulk, { updates });

    toast.success("Unit types updated");
    return res.data;
  } catch (error) {
    const message =
      error?.data?.error ||
      error?.data?.message ||
      error.message ||
      "Failed to update unit types";

    toast.error(message);
    throw error;
  }
};

/**
 * 🔥 NEW: Update structure (ADD / REMOVE units)
 */
export const updateFlatStructure = async (updates = []) => {
  const payload = updates;
  if (!payload || (Array.isArray(payload) && payload.length === 0)) return;

  try {
    const res = await api.post(API_ROUTES.flats.updateStructure, payload);

    toast.success("Units updated successfully");
    return res.data;
  } catch (error) {
    const message =
      error?.data?.error ||
      error?.data?.message ||
      error.message ||
      "Failed to update units";

    toast.error(message);
    throw error;
  }
};

/**
 * Get available staff in property for a department / flat
 */
export const getAvailableStaffForFlat = async (flatId) => {
  try {
    const res = await api.get(API_ROUTES.flats.availableStaff(flatId));
    return res.data;
  } catch (error) {
    const message =
      error?.data?.error ||
      error?.data?.message ||
      error.message ||
      "Failed to fetch available staff";
    toast.error(message);
    throw error;
  }
};

/**
 * Assign an existing staff member & workstation to flat / department
 */
export const assignStaffToFlat = async (flatId, payload) => {
  try {
    const res = await api.post(API_ROUTES.flats.assignStaff(flatId), payload);
    toast.success(res.data?.message || "Staff member allocated successfully");
    return res.data;
  } catch (error) {
    const message =
      error?.data?.error ||
      error?.data?.message ||
      error.message ||
      "Failed to allocate staff member";
    toast.error(message);
    throw error;
  }
};

/**
 * Unassign staff member from flat / department
 */
export const unassignStaffFromFlat = async (flatId, userId) => {
  try {
    const res = await api.post(API_ROUTES.flats.unassignStaff(flatId), { user_id: userId });
    toast.success(res.data?.message || "Staff member unassigned successfully");
    return res.data;
  } catch (error) {
    const message =
      error?.data?.error ||
      error?.data?.message ||
      error.message ||
      "Failed to unassign staff member";
    toast.error(message);
    throw error;
  }
};

